import $ from 'jquery'
import target from './target'
import Form from './Form';
import initRangeTime from './rangetime'

let isOpen = false;
let onExactClick = (function () {
	let mouseDownTarget = null;

	$(document).on('mousedown', function (e) {
		mouseDownTarget = e.target;
	});

	$(document).on('mouseup', function (e) {
		mouseDownTarget = null;
	});

	return function ($element, handler) {
		$element.on('mouseup', function (e) {
			if (mouseDownTarget === e.target) {
				handler(e);
			}
		});
	};
})();
let createForm = function () {
	$('.oc').remove();

	let el = document.createElement('div');
	el.className = 'oc';
	el.style.display = 'none';
	var $form = $(el);
	$form.append($(shopOrdercallConfig.form_html));

	$(document.body).append($form);


	shopOrdercallConfig.form_fields.forEach((field) => {
		let $field = $form.find(`[name="oc[${field['type']}]"]`);
		$field.styler();
		if (field.type === 'tel') {
			if (field.mask) {
				$('input[name=\'oc[tel]\']').mask(field.mask);
			}
		}
	});

	$form.find('.oc-form input[type=checkbox], .oc-light-form input[type=checkbox]').each(function () {
		var $this = $(this);

		$this.styler({
			onFormStyled: function () {
				$this.closest('.oc-light-form-checkbox.jq-checkbox').find('.jq-checkbox__div')
					.html('<svg class="oc-light-form-checkbox__icon" width="12" height="9" viewBox="0 0 12 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">'
						+ '<use class="oc-light-form-checkbox__icon-vector" xlink:href="#oc-light-form-checkbox-arrow" fill="#F2994A" />'
						+ '</svg>');
			}
		});
	});

	$form.find('.oc-form .oc-btn-accept, .oc-light-form__submit-button').on('click', function (e) {
		e.preventDefault();
		Form.send();
	});

	let $ocFormControl = $form.find('.oc-form__control');
	$ocFormControl.on('change', function () {
		if ($(this).val()) {
			$(this).addClass('not-empty');
		} else {
			$(this).removeClass('not-empty');
		}
	});
	$ocFormControl.change();

	$(document).on('click', '.oc .jq-selectbox ul', function (e) {
		if (!$(e.target).closest('li').length) {
			$(this).closest('.jq-selectbox').find('.jq-selectbox__select').click();
		}
	});

	$form.find('.oc-modal__close, .oc-btn-close, .oc-light-form__close-button').on('click', function () {
		close();
	});

	onExactClick($form, function (e) {
		if (!$(e.target).closest('.oc-modal, .oc-light-form').length) {
			close();
		}
	});

	$(document).keyup(function (e) {
		if (e.keyCode == 27) {
			close();
		}
	});

	initRangeTime();
	Form.fillOrdercallUserSpecifiedFields();
	return $form;
};

var $form = $();

function open() {
    isOpen = true;
    target('open');

    let scrollDiv = document.createElement('div');
    scrollDiv.className = 'modal-scrollbar-measure';
    $("body").append(scrollDiv);
    let scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    $("body").find(".modal-scrollbar-measure").remove();
    $form = createForm();

    $(document.body).css({paddingRight: scrollbarWidth}).addClass('oc-modal-open');
    setTimeout(function() {
        $('.oc-modal, .oc-light-form').animate({top: '0', opacity: 1}, 200, 'linear', function () {
            $(this).find(".oc-form__field").find("input, select, textarea").not(":hidden").eq(0).focus()
        });
    }, 200)
}

function close() {
    isOpen = false;
    $('.oc-modal, .oc-light-form').animate({top: '-25%', opacity: 0}, 200, 'linear', function () {
        $(document.body).removeClass('oc-modal-open').css({paddingRight: 0});
        $form.remove();
	    $('.oc').remove();
        $(".oc-modal, .oc-light-form").removeClass("success, error").find("#oc-modal-content").show().siblings(".oc-form__result").hide();
    })
}

export default {
    isOpen,
    open,
    close
}



// WEBPACK FOOTER //
// ./src/webpack/frontend/ordercall/Modal.js